import SpotifyWebApi from 'spotify-web-api-node'

export const spotifyApi = new SpotifyWebApi({
    clientId: process.env.REACT_APP_CLIENT_ID,
    redirectUri: process.env.REACT_APP_REDIRECT
})



export const GoAuth = () => {
    const scope = [
        "user-read-private",
        "user-read-email",
        "user-modify-playback-state",
        "user-read-playback-state",
        "user-read-currently-playing",
        "user-read-recently-played",
        "user-top-read"
    ]

    const apiUrl = process.env.REACT_APP_AUTH_ENDPOINT
    window.location.href = `${apiUrl}?client_id=${process.env.REACT_APP_CLIENT_ID}&redirect_uri=${process.env.REACT_APP_REDIRECT}&scope=${scope.join(
        " "
    )}&response_type=token&show_dialog=true`;
}

export const goBeezerAuth = () => {
    const YOU_APP_ID = '541022'
    const YOU_APP_SECRET = '53fe777eda460a6ad459bf13087014aa'
    const THE_CODE_FROM_ABOVE = 'fr666cfbd91d28b345c6209a2d25ac08'

    const apiCode = `https://connect.deezer.com/oauth/access_token.php?app_id=${YOU_APP_ID}&secret=${YOU_APP_SECRET}&code=${THE_CODE_FROM_ABOVE}`
    return window.location.href = apiCode
}